module.exports = __webpack_public_path__ + "static/meptik-a19fd7a9ab7a85c526f4fdf459bfc806.png";